/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Select_Target_WarningInputs */



/**
* | output |
* | --- |
* | "Please select a target location for automatic backups" |
*
* @param {Options_Backup_Select_Target_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_select_target_warning = /** @type {((inputs?: Options_Backup_Select_Target_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Select_Target_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez sélectionner un emplacement cible pour les sauvegardes automatiques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie einen Zielspeicherort für automatische Datensicherungen aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una posizione di destinazione per i backup automatici")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите целевое местоположение для автоматического резервного копирования.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una ubicación de destino para las copias de seguridad automáticas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择自动备份的目标位置。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップの保存先を選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया स्वचालित बैकअप के लिए लक्षित स्थान चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione um local de destino para backups automáticos.")
	return /** @type {LocalizedString} */ ("Please select a target location for automatic backups")
});